<template>
  <div>
    <label
      :for="selectId"
      class="block text-[10px] font-bold text-[#1c4848]/60 uppercase tracking-wider mb-1.5 ml-1"
    >{{ label }}</label>
    <select
      :id="selectId"
      :value="modelValue"
      class="w-full appearance-none bg-white border border-[#1c4848]/10 rounded-2xl px-4 py-3 text-sm font-medium text-[#1c4848] focus:outline-none focus:border-[#1c4848]/30 focus:ring-4 focus:ring-[#1c4848]/5 shadow-sm cursor-pointer"
      @change="emit('update:modelValue', $event.target.value)"
    >
      <option v-for="opt in UPLOAD_IMAGE_SIZE_SELECT_OPTIONS" :key="opt.value || 'none'" :value="opt.value">
        {{ opt.label }}
      </option>
    </select>
    <p v-if="hint" class="text-[10px] text-[#1c4848]/45 mt-1.5 ml-1">{{ hint }}</p>
  </div>
</template>

<script setup>
import { UPLOAD_IMAGE_SIZE_SELECT_OPTIONS } from '@/utils/uploadImageSizePresets.js';

defineProps({
  modelValue: { type: String, default: '' },
  selectId: { type: String, required: true },
  label: { type: String, default: 'Image size on upload' },
  hint: { type: String, default: 'Applies to JPEG/PNG uploads on save. Leave as original to skip.' },
});

const emit = defineEmits(['update:modelValue']);
</script>
